import axios from 'axios'

import type { AuthorizationTokenRefreshCreateResponse } from 'src/api/main'

import {
  ACCESS_TOKEN_KEY,
  DEVICE_TOKEN_KEY,
  REFRESH_TOKEN_KEY
} from '../constants'

export const setLocalStorageToken = (tokens: TokenPair) => {
  window.localStorage.setItem(ACCESS_TOKEN_KEY, tokens?.access || '')
  window.localStorage.setItem(REFRESH_TOKEN_KEY, tokens?.refresh || '')
}

export const getLocalStorageTokens = () => {
  const access = window.localStorage.getItem(ACCESS_TOKEN_KEY)
  const refresh = window.localStorage.getItem(REFRESH_TOKEN_KEY)

  return {
    access,
    refresh
  }
}

export const clearLocalStorage = () => {
  window.localStorage.removeItem(REFRESH_TOKEN_KEY)
  window.localStorage.removeItem(ACCESS_TOKEN_KEY)
}

export const setDeviceToken = (token: string) => {
  window.localStorage.setItem(DEVICE_TOKEN_KEY, token)
}

export const getDeviceToken = (): string | null => {
  return window.localStorage.getItem(DEVICE_TOKEN_KEY)
}

export const clearDeviceToken = () => {
  window.localStorage.removeItem(DEVICE_TOKEN_KEY)
}

type TokenPair = AuthorizationTokenRefreshCreateResponse

const getRefreshUrl = () => {
  const coreApiBase = import.meta.env.VITE_APP_CORE_API as string | undefined
  const base = coreApiBase || 'https://api.core.skalx.dev'

  return `${base.replace(/\/$/, '')}/authorization/token/refresh/`
}

export const exchangeRefreshForAccess = async (
  refresh: string
): Promise<TokenPair> => {
  const serviceToken = import.meta.env.VITE_APP_SERVICE_TOKEN as
    | string
    | undefined

  const { data } = await axios.post<Partial<TokenPair>>(
    getRefreshUrl(),
    {
      refresh,
      ...(serviceToken ? { service_token: serviceToken } : {})
    },
    { headers: { 'Content-Type': 'application/json' } }
  )

  if (!data.access) {
    throw new Error('No access token in refresh response')
  }

  return {
    access: data.access,
    refresh: data.refresh ?? refresh
  }
}

export const getRefreshToken = async (
  refreshToken: string
): Promise<TokenPair> => {
  const nextTokens = await exchangeRefreshForAccess(refreshToken)
  setLocalStorageToken(nextTokens)
  return nextTokens
}
